module.exports = __webpack_public_path__ + "img/zippykind-3.f7b24652.jpg";